import { atom } from 'jotai';

export const activeAtom = atom();
